import { ProCard } from '@ant-design/pro-components'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Alert, Typography } from 'antd'
import { FaArrowLeft } from 'react-icons/fa6'
import { DeleteLocalDatabaseAction } from './-actions/DeleteLocalDatabaseAction'
import { ExecSqlAction } from './-actions/ExecSqlAction'

export const Route = createFileRoute('/maintenance/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-4 p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold text-gray-900">Wartung</h1>
          <Typography.Text type="secondary">
            Werkzeuge zum Debuggen der lokalen App. Bitte mit Vorsicht verwenden.
          </Typography.Text>
        </div>
        <Link to="/" className="flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900">
          <FaArrowLeft />
          Zurück zur App
        </Link>
      </div>

      <Alert
        type="warning"
        showIcon
        description="Diese Aktionen können zu Datenverlust führen. Nur ausführen, wenn du weißt, was du tust."
      />

      <ProCard headerBordered title="Lokale Datenbank">
        <div className="flex flex-col">
          <DeleteLocalDatabaseAction />
          <div className="border-t border-gray-100 mt-4 pt-4">
            <ExecSqlAction />
          </div>
        </div>
      </ProCard>
    </div>
  )
}
